export default "__VITE_PUBLIC_ASSET__bfccb343__"